import { MapStyles } from "../../constants/mapStyles"

import {
    computeBrushParametrics,
    computeBrushRadiusAtMousePosition,
    createParametrics,
    initStateFromFeatures,
    initStateFromStartingFeatures,
} from "../utils/oneWayUtils"

export let RubberMode = {}

RubberMode.updateCursor = function () {
    const style = this.map.getStyle()
    const cursorFile = style.name === MapStyles.plan.name ? "circle_cursor_dark.png" : "circle_cursor_light.png"

    this.map.getCanvas().style.cursor = `url(assets/resources/${cursorFile}) 32 32, pointer`
}

RubberMode.onSetup = function (opts) {
    var state = {}

    state.options = opts

    state.roadSegments = opts.roadSegments
    state.startingFeatures = opts.startingFeatures

    this.map["dragPan"].disable()

    state.updateCursorFunction = this.updateCursor.bind(this)
    this.map.on("style.load", state.updateCursorFunction)
    this.updateCursor()

    const currentFeatures = opts.drawFeatures || []

    if (currentFeatures.length || opts.hasBeenUpdated) {
        state.parametricSegments = []
        state.featureIds = []

        initStateFromFeatures(state, currentFeatures)
    } else {
        const defaultParametrics = initStateFromStartingFeatures(state)
        createParametrics(this, state, defaultParametrics)
    }

    return state
}

RubberMode.onStop = function (state) {
    this.map.off("style.load", state.updateCursorFunction)
}

RubberMode.onDrag = function (state, e) {
    if (this.map && state.roadSegments) {
        const brushRadius = computeBrushRadiusAtMousePosition(this, e)

        const paintedParametrics = computeBrushParametrics(state, brushRadius, e)

        if (paintedParametrics.length) {
            const featuresUpdated = createParametrics(this, state, paintedParametrics, false)

            if (featuresUpdated) {
                this.map.fire("draw.paint_updated")
            }
        }
    }
}

RubberMode.onMouseDown = function (state, e) {
    this.onDrag(state, e)
}

RubberMode.toDisplayFeatures = function (state, geojson, display) {
    display(geojson)
}

RubberMode.onTrash = function (state) {
    const defaultParametrics = initStateFromStartingFeatures(state)
    createParametrics(this, state, defaultParametrics)
}